/* Shop the Look — Sync card images, prices, and order with selected PDP color */
(function() {
  var productCache = {};

  // Returns a Promise that resolves when all cards have been synced (cached or fetched)
  // so reorderLookCards can fire AFTER productCache is warm. See #101.
  function applyColorToLookCards(colorName) {
    var colorUpper = colorName.toUpperCase();
    var colorStripped = colorUpper.split(' (')[0];
    var cards = document.querySelectorAll('.s-pdp__look-card');

    var tasks = [];
    cards.forEach(function(card) {
      var img = card.querySelector('.s-pdp__look-card__image');
      if (!img) return;
      var href = card.getAttribute('href') || '';
      var match = href.match(/\/products\/([^?#]+)/);
      if (!match) return;
      var handle = match[1];

      if (productCache[handle]) {
        syncCardImageAndPricing(card, img, productCache[handle], colorUpper, colorStripped);
        return;
      }

      tasks.push(
        fetch('/products/' + handle + '.json')
          .then(function(r) { return r.json(); })
          // Stock fix: .json has no stock info, so every colour looked "in stock".
          // Merge live availability from .js so sold-out colours are never shown or linked.
          .then(function(data) {
            return fetch('/products/' + handle + '.js')
              .then(function(r) { return r.ok ? r.json() : null; })
              .catch(function() { return null; })
              .then(function(live) {
                var avail = {};
                ((live && live.variants) || []).forEach(function(v) { avail[v.id] = v.available; });
                ((data && data.product && data.product.variants) || []).forEach(function(v) {
                  if (Object.prototype.hasOwnProperty.call(avail, v.id)) v.available = avail[v.id];
                });
                return data;
              });
          })
          .then(function(data) {
            productCache[handle] = {
              images: data.product.images || [],
              variants: data.product.variants || []
            };
            syncCardImageAndPricing(card, img, productCache[handle], colorUpper, colorStripped);
          })
          .catch(function() {})
      );
    });
    return Promise.all(tasks);
  }

  // Fix #135: coordinate image + pricing so when the variant falls back to
  // a different color (e.g., >250-variant product where requested color isn't
  // in the .json response), the image matches the ACTUAL linked variant's color,
  // not the parent's requested color.
  // Refactored in #227: uses AP_COLOR_MATCH shared utility.
  // Extended in #282: 3-step match — exact → same-family → first available.
  function syncCardImageAndPricing(card, imgEl, cache, colorUpper, colorStripped) {
    // Step 1: try exact color match in variants
    var matchedVariant = AP_COLOR_MATCH.findColorMatchedVariant(cache.variants, colorUpper);

    if (matchedVariant) {
      setLookImage(imgEl, cache.images, colorUpper, colorStripped, cache.variants);
    } else {
      // Step 2: try same-family match (#282) — Pacific Blue → Royal Blue, etc.
      var familyVariant = AP_COLOR_MATCH.findFamilyMatchedVariant(cache.variants, colorUpper);
      if (familyVariant) {
        var famNorm = AP_COLOR_MATCH.normalizeColor(familyVariant.option1 || '');
        setLookImage(imgEl, cache.images, famNorm.upper, famNorm.stripped, cache.variants);
      } else {
        // Step 3: no exact and no family match — fall back to first available variant.
        var fallback = AP_COLOR_MATCH.findFallbackVariant(cache.variants);
        if (fallback) {
          var fbNorm = AP_COLOR_MATCH.normalizeColor(fallback.option1 || '');
          setLookImage(imgEl, cache.images, fbNorm.upper, fbNorm.stripped, cache.variants);
        }
      }
    }

    updateLookCardPricing(card, cache.variants, colorUpper, colorStripped);
  }

  // Refactored in #227 + #279: uses AP_COLOR_MATCH.findColorMatchedImage with
  // variant→image link as primary signal. Variants are passed through so the
  // util can resolve image_id → image without depending on alt-text format.
  function setLookImage(imgEl, images, colorUpper, colorStripped, variants) {
    var matched = AP_COLOR_MATCH.findColorMatchedImage(images, colorUpper, true, variants);
    if (matched) {
      imgEl.src = matched.src.replace(/\?.*/, '?width=400');
    }
  }

  // Refactored in #227: uses AP_COLOR_MATCH for variant matching.
  // Price is parseFloat(v.price) — product JSON returns dollars (NOT cents).
  // Extended in #282: 3-step match — exact → same-family → first available.
  function updateLookCardPricing(card, variants, colorUpper, colorStripped) {
    var priceEl = card.querySelector('[data-look-price]');
    var badgeEl = card.querySelector('[data-look-badge]');
    if (!priceEl) return;

    // Step 1: exact color match. Step 2: same-family match (#282).
    // Treat a family-matched variant the same as an exact one for href + price —
    // it's a real, in-stock variant in the same color family.
    var matchedV = AP_COLOR_MATCH.findColorMatchedVariant(variants, colorUpper);
    if (!matchedV) matchedV = AP_COLOR_MATCH.findFamilyMatchedVariant(variants, colorUpper);
    var matched = matchedV ? { price: parseFloat(matchedV.price), id: matchedV.id } : null;

    // Strip any existing color/variant params from href
    var href = card.getAttribute('href') || '';
    var cleaned = href.replace(/[?&](color|variant)=[^&]*/g, '').replace(/\?$/, '');

    if (!matched) {
      // Step 3: no exact and no family match. Fall through to first-available
      // variant so the Shop the Look section is never left visually empty after
      // a color change. See #101. Reordering pushes color-relevant cards to the
      // front so the customer sees them first.
      card.style.display = '';
      var fallbackV = AP_COLOR_MATCH.findFallbackVariant(variants);
      if (fallbackV) {
        var fallback = { price: parseFloat(fallbackV.price), id: fallbackV.id };
        var fbSep = cleaned.includes('?') ? '&' : '?';
        card.setAttribute('href', cleaned + fbSep + 'variant=' + fallback.id);
        priceEl.innerHTML = '$' + fallback.price.toFixed(2);
      } else {
        card.setAttribute('href', cleaned);
      }
      if (badgeEl) badgeEl.style.display = 'none';
      return;
    }

    // Matched variant found and available — ensure card is visible
    card.style.display = '';

    var sep = cleaned.includes('?') ? '&' : '?';
    card.setAttribute('href', cleaned + sep + 'variant=' + matched.id);

    priceEl.innerHTML = '$' + matched.price.toFixed(2);
    if (badgeEl) badgeEl.style.display = 'none';
  }

  // Compute a sort tier for a card relative to the selected color.
  // Warm-cache (variants cached): delegates to AP_COLOR_MATCH.colorMatchTier
  // which returns the 5-tier score (#282):
  //   0 = exact, in stock              1 = same family, in stock
  //   2 = exact, OOS                   3 = same family, OOS
  //   4 = no color match
  // Cold-cache (no fetch yet): reads data-product-colors DOM attribute as an
  // offers-only signal — can't tell stock status, so map optimistically:
  //   exact-offered → 1   family-offered → 3   no-offer → 4
  // After all fetches complete, the second pass with warm cache resolves
  // cards to their accurate tier. See #101.
  function cardColorTier(card, colorUpper, colorStripped) {
    var href = card.getAttribute('href') || '';
    var match = href.match(/\/products\/([^?#]+)/);
    var handle = match ? match[1] : null;

    if (handle && productCache[handle]) {
      return AP_COLOR_MATCH.colorMatchTier(productCache[handle].variants || [], colorUpper);
    }

    var colors = (card.getAttribute('data-product-colors') || '').toUpperCase();
    var srcFam = (typeof window !== 'undefined' && window.AP_COLOR_MAP && window.AP_COLOR_MAP.getFamily)
      ? window.AP_COLOR_MAP.getFamily(colorUpper) : null;
    var offersExact = false, offersFamily = false;
    var arr = colors.split(',');
    for (var i = 0; i < arr.length; i++) {
      var v = arr[i];
      if (!v) continue;
      var vTrim = v.trim();
      var vs = vTrim.split(' (')[0];
      if (vTrim === colorUpper || vs === colorStripped) { offersExact = true; continue; }
      if (srcFam) {
        var vFam = window.AP_COLOR_MAP.getFamily(vTrim);
        if (vFam && vFam === srcFam) offersFamily = true;
      }
    }
    if (offersExact) return 1;
    if (offersFamily) return 3;
    return 4;
  }

  function reorderLookCards(colorName) {
    var colorUpper = colorName.toUpperCase();
    var colorStripped = colorUpper.split(' (')[0];
    var slider = document.querySelector('[data-look-slider]');
    if (!slider) return;

    var cards = Array.from(slider.querySelectorAll('.s-pdp__look-card'));
    if (cards.length < 2) return;

    // Stable sort: preserve original order within each tier by using indexed sort
    var indexed = cards.map(function(c, i) {
      return { card: c, tier: cardColorTier(c, colorUpper, colorStripped), idx: i };
    });
    indexed.sort(function(a, b) {
      if (a.tier !== b.tier) return a.tier - b.tier;
      return a.idx - b.idx;
    });
    indexed.forEach(function(entry) { slider.appendChild(entry.card); });
    slider.scrollLeft = 0;

    // Stock fix: only show items whose exact colour is in stock. If fewer than
    // LOOK_MIN_EXACT match, fill with other in-stock items (shown in their
    // in-stock colour). Items with nothing in stock are never shown.
    var LOOK_MIN_EXACT = 4;
    var stockOf = function(card) {
      var m = (card.getAttribute('href') || '').match(/\/products\/([^?#]+)/);
      var c = m && productCache[m[1]];
      if (!c) return null; // not loaded yet
      return c.variants.some(function(v) { return v.available !== false; });
    };
    var anyLoaded = indexed.some(function(e) { return stockOf(e.card) !== null; });
    if (anyLoaded) {
      var exactCount = indexed.filter(function(e) { return e.tier === 0 && stockOf(e.card) === true; }).length;
      var visibleCount = 0;
      indexed.forEach(function(e) {
        var stock = stockOf(e.card);
        var show = stock !== false && (e.tier === 0 || exactCount < LOOK_MIN_EXACT);
        e.card.style.display = show ? '' : 'none';
        if (show) visibleCount++;
      });
      var lookSection = slider.closest('[data-match-section]');
      if (lookSection) lookSection.style.display = visibleCount ? '' : 'none';
    }
  }

  function init() {
    // Guard: AP_COLOR_MATCH must be loaded before this IIFE runs.
    // Both scripts use defer and are ordered in theme.liquid, so this
    // should always be true — but guard defensively per #227 RISK-2.
    if (typeof AP_COLOR_MATCH === 'undefined') {
      console.warn('[look-color-sync] AP_COLOR_MATCH not loaded — color sync disabled');
      return;
    }
    var swatches = document.querySelectorAll('.s-pdp__color-swatch');
    if (!swatches.length) return;

    // #282: On PDP init, apply color sync + reorder using the currently-selected
    // color. Liquid renders cards using exact-color match only and falls back to
    // variants[0] when no exact-color variant exists, which produces wrong-color
    // cards when the source color is unique to one product (e.g., Pacific Blue
    // underscrub). The JS pass overlays family fallback so those cards switch
    // to a same-family image/price/href before paint settles. See #76 / #101 —
    // the prior init policy ("don't touch prices/hrefs") is superseded because
    // family fallback fundamentally needs JS to run on init, not just on click.
    // URL ?color= takes precedence over the .is-selected swatch — at the time
    // deferred scripts run, Liquid has only rendered is-selected on the
    // product's default variant color. The URL→swatch auto-select script in
    // main-product.liquid runs later (DOMContentLoaded) and re-clicks the
    // matching swatch. Reading the URL up-front gets the user's chosen color
    // without waiting for that race to resolve.
    var initColor = null;
    var urlColor = new URLSearchParams(window.location.search).get('color');
    if (urlColor) initColor = urlColor;
    if (!initColor) {
      var selected = document.querySelector('.s-pdp__color-swatch.is-selected');
      if (selected) initColor = selected.getAttribute('data-option-value');
    }
    // #282 init-time apply. The look slider can be populated by either Liquid
    // (static, present at parse time) or theme.js renderRecs (async, appended
    // after the recommendations API resolves). Two-phase approach:
    //   1. If cards are already present, apply immediately.
    //   2. Watch the slider for added cards (theme.js append) and re-apply
    //      once they arrive. Throttled via a flag so duplicate appends don't
    //      thrash. The observer disconnects after a single successful run —
    //      subsequent swatch clicks handle further sync.
    if (initColor) {
      var lastCount = 0;
      function applyNow() {
        var cardsNow = document.querySelectorAll('.s-pdp__look-card');
        if (cardsNow.length === 0) return;
        if (cardsNow.length === lastCount) return; // re-run only if new cards arrived
        lastCount = cardsNow.length;
        setTimeout(function() { reorderLookCards(initColor); }, 50);
        applyColorToLookCards(initColor).then(function() { reorderLookCards(initColor); });
      }
      applyNow();
      // The Shop the Look section + its cards are typically rendered AFTER
      // deferred scripts run (theme.js renderRecs appends cards async via the
      // Recommendations API; the s-pdp__complete-set wrapper is a sibling of
      // .s-pdp). Observe document.body to catch the section + card additions
      // wherever they land. The lastCount guard prevents redundant re-runs;
      // productCache prevents duplicate fetches.
      if (typeof MutationObserver !== 'undefined') {
        var mo = new MutationObserver(function() { applyNow(); });
        mo.observe(document.body, { childList: true, subtree: true });
        // Safety timeout — disconnect after 8s once cards are stable.
        setTimeout(function() { mo.disconnect(); }, 8000);
      }
    }

    swatches.forEach(function(swatch) {
      swatch.addEventListener('click', function() {
        var color = this.getAttribute('data-option-value');
        if (!color) return;
        // Kick off an immediate reorder using whatever cache data is warm so
        // color-matched cards start sliding to the front without waiting for fetches.
        setTimeout(function() { reorderLookCards(color); }, 50);
        // Then sync all cards (prices, images, hrefs). When all fetches complete,
        // re-reorder now that productCache has live stock data — this promotes
        // cards that actually have IN-STOCK variants in the selected color to the
        // front, even if data-product-colors didn't predict it. See #101.
        applyColorToLookCards(color).then(function() { reorderLookCards(color); });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* PDP safety net: if a link (old link, ad, Google) opens a sold-out colour or size,
   switch to an in-stock option: same colour in another size if possible,
   otherwise the first in-stock colour. Uses the theme's own swatch/size buttons. */
(function() {
  function findOptionButton(optionIndex, value) {
    if (!value) return null;
    var wrap = document.querySelector('#product-form .s-pdp__option[data-option-index="' + optionIndex + '"]');
    if (!wrap) return null;
    var btns = wrap.querySelectorAll('button[data-option-value]');
    var want = String(value).toUpperCase();
    for (var i = 0; i < btns.length; i++) {
      if (String(btns[i].getAttribute('data-option-value')).toUpperCase() === want) return btns[i];
    }
    return null;
  }

  function run() {
    var idInput = document.querySelector('#product-form input[name="id"]');
    var path = window.location.pathname.replace(/\/$/, '');
    if (!idInput || path.indexOf('/products/') === -1) return;

    fetch(path + '.js')
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(p) {
        if (!p || !p.variants) return;
        var cur = null, i;
        for (i = 0; i < p.variants.length; i++) {
          if (String(p.variants[i].id) === String(idInput.value)) cur = p.variants[i];
        }
        if (!cur || cur.available) return;

        // 1) same colour, another size in stock
        for (i = 0; i < p.variants.length; i++) {
          var v = p.variants[i];
          if (v.available && v.option1 === cur.option1 && v.option2) {
            var sizeBtn = findOptionButton(1, v.option2);
            if (sizeBtn) { sizeBtn.click(); return; }
          }
        }
        // 2) first colour that has stock (theme picks its first in-stock size)
        for (i = 0; i < p.variants.length; i++) {
          if (p.variants[i].available) {
            var colorBtn = findOptionButton(0, p.variants[i].option1);
            if (colorBtn) { colorBtn.click(); return; }
          }
        }
      })
      .catch(function() {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
